import { Boundaries } from "@planzone/core";
import { createStateReducer } from "../../utils/createStateReducer";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { resetState } from "../../utils/resetState";
import { events } from "@planzone/events";
import { State, Selector } from "./types";
import { createSelector } from "./selector";

const initialState: State = [];

function handleRequest(
  state: State,
  { project, resource }: Boundaries["retrieveTasks"]["request"],
): State {
  const resIndex = state.findIndex(
    (r) => r.project.uuid === project.uuid && r.resource.uuid === resource.uuid,
  );

  return resIndex >= 0
    ? [
        ...state.slice(0, resIndex),
        { ...state[resIndex], request: setRequestStateToPending() },
        ...state.slice(resIndex + 1),
      ]
    : [
        ...state,
        {
          project,
          resource,
          request: setRequestStateToPending(),
          tasks: [],
        },
      ];
}

function handleSuccess(
  state: State,
  { tasks, project, resource }: Boundaries["retrieveTasks"]["success"],
): State {
  return state.map((res) =>
    res.project.uuid === project.uuid && res.resource.uuid === resource.uuid
      ? { ...res, request: setRequestStateToSuccess(), tasks }
      : res,
  );
}

function handleFailure(
  state: State,
  { project, resource }: Boundaries["retrieveTasks"]["failure"],
): State {
  return state.map((res) =>
    res.project.uuid === project.uuid && res.resource.uuid === resource.uuid
      ? { ...res, request: setRequestStateToFailure() }
      : res,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.retrieveTasksRequested]: handleRequest,
    [events.retrieveTasksSucceeded]: handleSuccess,
    [events.retrieveTasksFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
